<template>
<div class="deviceNoBind">
   <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span style="line-height: 36px; text-align: center;">设备告警汇总</span>
      <div style="float:right">
        <!-- <el-input placeholder="昵称/地址" v-model="keyWord">
          <el-select v-model="sltValue" slot="prepend" placeholder="请选择">
            <el-option label="设备编号" value="0"></el-option>
            <el-option label="设备昵称" value="1"></el-option>
            <el-option label="设备地址" value="2"></el-option>
          </el-select>
          <el-button slot="append" icon="search" @click="getDeviceList"></el-button>
        </el-input> -->

        <el-select v-model="alarmType" placeholder="问题类型">
          <el-option
            v-for="item in alarmTypes"
            :key="item.alias"
            :label="item.alias"
            :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="alarmStatus" placeholder="状态">
          <el-option
            v-for="item in alarmStatuses"
            :key="item.value"
            :label="item.value"
            :value="item.key">
          </el-option>
        </el-select>
        <el-input v-model="deviceCode" placeholder="设备编号" style="width: 150px;" @keyup.enter.native="btnSearch"></el-input>
        <el-button type="success" @click="btnSearch">搜索</el-button>
      </div>
    </div>
    <div>
      <el-table
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="deviceData"
      stripe
      border
      fit
      height="520"
      style="width: 100%">
      <el-table-column
        prop="id"
        header-align="center"
        min-width="80"
        label="编号">
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        width="125"
        label="时间">
      </el-table-column>
      <el-table-column
        prop="deviceCode"
        header-align="center"
        width="165"
        label="设备编号">
      </el-table-column>
      <el-table-column
        prop="deviceAlias"
        header-align="center"
        min-width="100"
        label="昵称">
      </el-table-column>
       <el-table-column
        prop="deviceAddress"
        header-align="center"
        min-width="150"
        label="地址">
      </el-table-column>
      <el-table-column
        prop="alias"
        header-align="center"
        min-width="150"
        label="问题类型">
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        min-width="100"
        label="状态">
        <template scope="scope">
        <el-tag :type="scope.row.status === 0 ? 'danger' : 'success'"
        close-transition>{{scope.row.status === 0 ? '不正常': '正常'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="repeatCount"
        header-align="center"
        min-width="120"
        label="7天重复">
      </el-table-column>
    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </el-card>
  </div>
</template>
<script>
    import $axios from '../../https/config'

    export default {
      data () {
        return {
          deviceData: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          table_loading: false,
          alarmTypes: [],
          alarmType: '',
          alarmStatuses: [{
            key: '',
            value: '状态'
          }, {
            key: 1,
            value: '正常'
          }, {
            key: 0,
            value: '不正常'
          }],
          alarmStatus: '',
          deviceCode: ''
        }
      },
      created: function () {
        this.pageNo = 1
        this.getSpaseTypeList()
        this.queryDeviceList(this.pageNo, this.pageSize, this.alarmType, this.alarmStatus, this.deviceCode)
      },
      methods: {
        btnSearch () {
          this.queryDeviceList(this.pageNo, this.pageSize, this.alarmType, this.alarmStatus, this.deviceCode)
        },
        getSpaseTypeList () {
          var _this = this
          $axios.get('/device/queryFaultType', null, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              _this.alarmTypes = res.resultData.list
              _this.alarmTypes.unshift({
                id: '',
                alias: '问题类型'
              })
            }
          })
        },
        queryDeviceList (tPageNo, tPageSize, tFaultId, tStatus, tDeviceCode) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            faultId: tFaultId,
            status: tStatus,
            deviceCode: tDeviceCode
          }
          this.table_loading = true
          this.deviceData = []
          $axios.get('/device/queryDeviceFaultList', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                _this.deviceData = res.resultData.list
              }
            } else {
            }
            _this.table_loading = false
          }, function () {
          })
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryDeviceList(this.pageNo, this.pageSize, this.alarmType, this.alarmStatus, this.deviceCode)
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryDeviceList(this.pageNo, this.pageSize, this.alarmType, this.alarmStatus, this.deviceCode)
        }
      }
    }
</script>
<style lang="scss">
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
    .deviceNoBind {
        .el-select .el-input {
          width: 110px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/deviceMgr/alarmSummary.vue